import * as React from "react";
import { fontColorDark, calloutField } from "./shared.module.scss";
import ApplyButton from "./applyButton";
import { utinc } from "./tiny_components/priceDisplay.module.scss";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const UnitDisplayCards = ({
  floorplanResults,
  slug,
  deals,
  dollhouse,
  utilitiesIncluded = false,
  showDollhouse = true,
  calloutFieldText = '',
  communityName,
}) => {
  if (!floorplanResults || !floorplanResults.hasVacantUnits) {
    return null;
  }
  const { lowestPricedUnit, middlePricedUnit, highestPricedUnit } =
    floorplanResults;

  //console.log("one", lowestPricedUnit);
  //console.log("two", middlePricedUnit);
  //console.log("three", highestPricedUnit);

  const dealName = (deals, unit) => {
    for (let element of deals) {
      if (element.unit == unit.trim()) {
        if(slug == 'ivy-flats'){
          if(element.sdesc.includes('The Bellmar')){
            return element.sdesc1;
          }
        }else if(element.unit == '1962-202' && element.sdesc1 == '100.00'){
          return '1 Months Free - Wooded View!';
        }else{
        return element.sdesc1;
        }
      }
    }
  };

  const avnow = ["Vacant Unrented Not Ready", "Vacant Unrented Ready"]; // available now status
  const avsoon = ["Notice Unrented"]; // available soon status

  function flipDate(dateStr) {
    const [year, month, day] = dateStr.split("-");
    return `${month}-${day}-${year}`;
  }
  function calcReadyDate(dateStr) {
    // Parse the input date string into a Date object
    let date = new Date(dateStr);

    // Add 3 days to the date
    date.setDate(date.getDate() + 3);

    // Extract the year, month, and day from the new date
    let year = date.getFullYear();
    let month = date.getMonth() + 1; // Months are zero-indexed
    let day = date.getDate();

    // Helper function to pad single-digit months and days with a leading zero
    function pad(n) {
      return n < 10 ? "0" + n : n;
    }

    // Return the date in MM-DD-YYYY format
    return `${pad(month)}-${pad(day)}-${year}`;
  }

  const renderCard = (unit) => {
    //console.log(unit);
    if (!unit) return null; // Do not render if the unit is undefined

    const dealNameText = dealName(deals, unit.unit);

    return (
      <div className="column" key={unit.unit} style={{ textAlign: "center" }}>
        <div className="card" style={{ maxWidth: "432px", margin: "0 auto" }}>
          <div className="card-content">
            <div className="content">
              <div className="columns">
                <div className="column">
                  {dealNameText && (
                    <div className="floorplan-deal-text-card">
                      {dealNameText}
                    </div>
                  )}
                </div>
              </div>
              <div className="columns">
                <div className="column">
                  <p style={{ textAlign: "center" }} className={fontColorDark}>
                    Building
                    <br />
                    {unit.unit}
                  </p>
                </div>
                <div className="column">
                  <p style={{ textAlign: "center" }} className={fontColorDark}>
                    Monthly Rent <br />${Number(unit.price)}
                    {utilitiesIncluded ? "*" : ""}
                    {utilitiesIncluded && (
                      <span className={utinc}>*Utilities Included</span>
                    )}
                  </p>
                </div>
              </div>
              <div className="columns">
                <div className="column">
                  {showDollhouse && (
                    <GatsbyImage
                      image={getImage(dollhouse)}
                      alt="Floorplan Image"
                    />
                  )}
                  {calloutFieldText && (
                    <p style={{ textAlign: "center" }} className={calloutField}>
                      {calloutFieldText}
                    </p>
                  )}
                  <p style={{ textAlign: "center" }} className={fontColorDark}>
                    {avnow.includes(unit.status)
                      ? "Available Now"
                      : avsoon.includes(unit.status)
                        ? "Available Soon"
                        : "Contact Us"}
                  </p>
                  {unit.moveOutDate && !unit.isVacant && unit.otherDate && (
                    <p style={{ textAlign: "center" }}>
                      {calcReadyDate(unit.moveOutDate)}
                    </p>
                  )}
                  <p style={{ textAlign: "center" }}>
                    <ApplyButton
                      slug={slug}
                      communityName={communityName}
                      marginRight="0"
                      isInHeader="false"
                    />
                  </p>
                  <br />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Component return
  return (
    <section id="unit_display_cards_wrap">
      <div className="container">
        <div className="columns is-padded">
          {renderCard(lowestPricedUnit)}
          {renderCard(middlePricedUnit)}
          {renderCard(highestPricedUnit)}
        </div>
      </div>
    </section>
  );
};

export default UnitDisplayCards;
